module.exports = __webpack_public_path__ + "static/media/Pan Release.512ec2d0.jpg";